import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';


const InvoiceListLayer = ({jobsData}) => {
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})
      const handleDelete = async(id)=>{
        const user = JSON.parse(localStorage.getItem('user'))
        
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(API_URL+`/api/invoice/delete-invoice/${user.id}/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="Invoice deleted successfully"){
            window.location.reload();
         }
      }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'invoice_number' },
            { data: 'customer_name' },
            { data: 'phone' },
            { data: 'issue_date' },
            { data: 'due_date' },
            { data: 'amount' ,
            render: function (data, type, row) {
                // Return HTML string for buttons
                return `
               <span>${parseFloat(data).toFixed(2)}</span>
               
                `;
              }, },
            { data: 'status' },
           
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <button class="btn btn-success view-btn" data-id="${row.id}"><i class="ph ph-eye"></i></button>
                <button class="btn btn-primary edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i></button>
                <button class="btn btn-danger delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i></button>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/invoice-edit/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/invoice-preview/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Invoices</h5>
            <div class="col-md-6 text-end">
            <Link className="btn btn-info" to={'/invoice-add'}>
              Add New
            </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
           
                <th scope="col">InvoiceNo</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Customer Phone</th>
             
                <th scope="col">Issued Date</th>
                <th scope="col">Due Date</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default InvoiceListLayer